import Alpine from 'alpinejs';

// Components

// Global
window.Alpine = Alpine;

const initStickyNav = () => {
	const nav = document.querySelector('.main-nav');
	const navWrap = document.querySelector('.main-nav__wrap');
	if (!nav || !navWrap) {
		return;
	}

	const threshold = 200;
	let isPinned = false;
	let removeTimer = null;
	let lastScrollY = window.scrollY;

	const pinNav = () => {
		if (isPinned) {
			return;
		}

		isPinned = true;
		if (removeTimer) {
			window.clearTimeout(removeTimer);
			removeTimer = null;
		}

		navWrap.style.height = `${nav.offsetHeight}px`;
		navWrap.classList.add('main-nav__wrap--fixed');
		nav.classList.add('main-nav--fixed');

		window.requestAnimationFrame(() => {
			nav.classList.add('main-nav--visible');
		});
	};

	const unpinNav = () => {
		if (!isPinned) {
			return;
		}

		isPinned = false;
		nav.classList.remove('main-nav--visible');

		removeTimer = window.setTimeout(() => {
			nav.classList.remove('main-nav--fixed');
			navWrap.classList.remove('main-nav__wrap--fixed');
			navWrap.style.height = '';
			removeTimer = null;
		}, 280);
	};

	const syncNav = () => {
		const currentScrollY = window.scrollY;
		const scrollingUp = currentScrollY < lastScrollY;

		if (currentScrollY <= threshold) {
			unpinNav();
		} else if (scrollingUp) {
			unpinNav();
		} else {
			pinNav();
		}

		lastScrollY = currentScrollY;
	};

	window.addEventListener('scroll', syncNav, { passive: true });
	window.addEventListener('resize', () => {
		if (isPinned) {
			navWrap.style.height = `${nav.offsetHeight}px`;
		}
	});

	syncNav();
};

// Inits
Alpine.start();
initStickyNav();
